import lockr from "lockr";

lockr.prefix = "jasper-app-";

export const doKeysMatch = (key, rawKeyFromLocalStorage) =>
	rawKeyFromLocalStorage === `${lockr.prefix}${key}`;

export default lockr;
